<button 
  mat-raised-button
  [color]="buttonType === 'Primary' ? 'primary' : buttonType === 'Secondary' ? 'accent' : 'basic'"
  [disabled]="disabled ?? false"
  [ngClass]="cssClass ?? ''"
  (click)="handleClick(buttonUseCase)"
  class="button-group-button"
>
  <mat-icon *ngIf="icon && iconPosition === 'Left'" class="button-icon left-icon">{{ icon }}</mat-icon>
  <span class="button-label">{{ label ?? 'Submit' }}</span>
  <mat-icon *ngIf="icon && iconPosition === 'Right'" class="button-icon right-icon">{{ icon }}</mat-icon>
</button>
